import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { GlassVariant } from './types';
import { ORIGIN_TOKENS } from './tokens';

interface OriginGlassProps {
  children: ReactNode;
  variant?: GlassVariant;
  className?: string;
  style?: React.CSSProperties;
  noAnimation?: boolean;
}

const OriginGlass: React.FC<OriginGlassProps> = ({
  children,
  variant = 'soft',
  className = '',
  style = {},
  noAnimation = false
}) => {
  const token = ORIGIN_TOKENS.glass[variant as 'soft' | 'panel' | 'overlay'];
  
  const baseStyles: React.CSSProperties = {
    backdropFilter: `blur(${token.blur})`,
    WebkitBackdropFilter: `blur(${token.blur})`,
    backgroundColor: token.bg,
    border: `1px solid ${token.border}`,
    boxShadow: token.shadow,
    borderRadius: variant === 'panel' ? 'var(--origin-radius-panel)' : 'var(--origin-radius-soft)',
    ...style
  };

  if (noAnimation) {
    return (
      <div className={`origin-glass origin-glass--${variant} ${className}`} style={baseStyles}>
        {children}
      </div>
    );
  }

  const MotionDiv = motion.div as any;

  return (
    <MotionDiv
      className={`origin-glass origin-glass--${variant} ${className}`}
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={ORIGIN_TOKENS.motion.transition}
      style={baseStyles}
    >
      {children}
    </MotionDiv>
  );
};

export default OriginGlass;
